
  import {IonRow, IonGrid, IonCol, IonImg, IonRefresher, IonRefresherContent, IonBadge, IonTitle, IonToolbar, IonHeader, IonList, IonButtons, IonMenuButton, IonCard, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonContent, IonPage, IonItem, toastController  } from '@ionic/vue';
  import axios from 'axios';
  import { pencil, chevronForwardOutline } from 'ionicons/icons';
  import {mapGetters} from "vuex";
  import _ from 'lodash';

  export default {
    components: {IonRow, IonGrid, IonCol, IonImg, IonRefresher, IonRefresherContent, IonBadge, IonTitle, IonToolbar, IonHeader, IonList, IonButtons, IonMenuButton,IonCard, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonContent, IonPage, IonItem},
    computed: {
      ...mapGetters({
        articles: "getAffiliations"
      })
    },
    setup(){
      return {pencil, chevronForwardOutline};
    },
    data(){
      return {
        loading: false,
      };
    },
    beforeMount(){
      this.loading = true;
      this.$store.dispatch('apiGetAffiliations').finally(() => {
        this.loading = false;
      });
    },
    methods: {
      refreshData(event){
        this.$store.dispatch('apiGetAffiliations').finally(() => {
          event.target.complete();
        });
      },
      testSearch(event){
        console.log("event: ", event);
      },
      openDetails(index){
        this.$router.push('/affiliations/'+index);
      },
      async presentToast(message, color) {
        const toast = await toastController.create({
          message: message,
          duration: 1500,
          position: 'bottom',
          color: color || 'primary'
        });

        await toast.present();
      },
    },
  };
